import { Box, Divider, MenuItem } from "@mui/material";
import { VTextField } from "../../../../shared/forms";

import { SicoobLogo } from "../../../../assets/banks/SicoobLogo";
import { SicoobCredimepiLogo } from "../../../../assets/banks/SicoobCredimepiLogo";
import { PJBankLogo } from "../../../../assets/banks/PjbankLogo";
import { AsaasLogo } from "../../../../assets/banks/AsaasLogo";

const GATEWAY_LOGOS: Record<string, React.ReactNode> = {
	PJBANK: <PJBankLogo height={28} />,
	SICOOB: <SicoobLogo height={28} />,
	CREDIMEPI: <SicoobCredimepiLogo height={28} />,
	ASAAS: <AsaasLogo height={14} />,
};

export const GatewayLogo = ({ gateway }: { gateway?: string | null }) => <>{GATEWAY_LOGOS[gateway ?? ""] ?? null}</>;

export const INVOICE_GATEWAYS = ["PJBANK", "SICOOB", "CREDIMEPI", "ASAAS"];
export const SETUP_GATEWAYS = ["PJBANK", "ASAAS"];

interface IGatewaySelectProps {
	label: string;
	name: string;
	options: string[];
	isLoading: boolean;
}

export const GatewaySelect: React.FC<IGatewaySelectProps> = ({ label, name, options, isLoading }) => (
	<VTextField
		fullWidth
		label={label}
		name={name}
		disabled={isLoading}
		select
		InputLabelProps={{ shrink: true }}
		SelectProps={{
			displayEmpty: true,
			renderValue: (value) => (
				<Box sx={{ display: "flex", alignItems: "center", gap: 1, pl: 0 }}>
					{GATEWAY_LOGOS[value as string]}
				</Box>
			),
			sx: {
				"& .MuiSelect-select": {
					paddingLeft: "0 !important",
					paddingRight: 0,
					display: "flex",
					alignItems: "center",
				},
				"& .MuiOutlinedInput-input": {
					paddingLeft: "0 !important",
				},
				"& .MuiInputBase-input": {
					paddingLeft: "0 !important",
				},
			},
		}}
	>
		{options.map((gateway, index) => [
			index > 0 ? <Divider key={`${gateway}-divider`} component="li" sx={{ my: 0.5 }} /> : null,
			<MenuItem key={gateway} value={gateway} sx={{ pl: 0 }}>
				<Box display="flex" alignItems="center" gap={1}>
					{GATEWAY_LOGOS[gateway]}
				</Box>
			</MenuItem>,
		])}
	</VTextField>
);
